module.exports = __webpack_public_path__ + "img/s33.9bf7b58d.jpg";